import React from 'react';
import { Control, Controller, FieldErrorsImpl, RegisterOptions } from 'react-hook-form';
import { Typography } from '@navi/web-ui/lib/primitives';
import ErrorIconOutline from '@cp/src/assets/icons/ErrorIconOutline';
import cx from 'classnames';
import RequiredIcon from '@navi/web-ui/lib/icons/RequiredIcon';
import DateTimePickerComponent from '@cp/src/components/DateTimePicker/DateTimePickerComponent';
import { DATE_TIME_TYPE } from '@cp/src/components/DateTimePicker/constants';
import { AgentFormValues } from '../../interfaces/types';

type AgentFormDateInputProps = {
  control: Control<AgentFormValues, any>;
  name: keyof AgentFormValues;
  rules: RegisterOptions;
  errors: Partial<FieldErrorsImpl<AgentFormValues>>;
  isEditDisabled?: boolean;
  styles: CSSModuleClasses;
  inputLabel: string;
  placeholder: string;
  validationMessage: string;
  defaultSelected: string | null;
  showRequiredIcon?: boolean;
};

const AgentFormDateInput: React.FC<AgentFormDateInputProps> = props => {
  const {
    control,
    name,
    rules,
    errors,
    isEditDisabled = false,
    styles,
    validationMessage,
    inputLabel,
    defaultSelected,
    showRequiredIcon = false
  } = props;

  const getMaxInputDateAllowed = () => {
    const todaysDate = new Date();
    const maxDate = new Date(
      todaysDate.getFullYear() - 18,
      todaysDate.getMonth(),
      todaysDate.getDate() + 1
    );
    return maxDate.toISOString().split('T')[0];
  };

  const handleDateChange = (date: string, fieldOnChange: (value: string) => void) => {
    fieldOnChange(date);
  };
  return (
    <>
      <div className={cx(styles.textContainer, 'pb-1')}>
        <Typography variant="p4" color="var(--navi-color-gray-c2)">
          {inputLabel}
        </Typography>
        {showRequiredIcon && <RequiredIcon />}
      </div>
      <Controller
        control={control}
        name={name}
        rules={rules}
        render={({ field: { onChange, value } }) => (
          <DateTimePickerComponent
            type={DATE_TIME_TYPE.DATE}
            containerClasses={styles.datePickerContainer}
            inputClasses={cx(styles.dateSelector, {
              [styles.selectedDateContainer]: value,
              [styles.placeholder]: defaultSelected
            })}
            value={value || (defaultSelected as any)}
            onChange={date => handleDateChange(date, onChange)}
            max={getMaxInputDateAllowed()}
            disabled={isEditDisabled}
            customLabelColor={!value ? styles.placeholder : ''}
          />
        )}
      />
      {errors?.[name] && (
        <div className={styles.errorContainer}>
          <ErrorIconOutline />
          <Typography variant="p4" className={styles.errorText}>
            {validationMessage}
          </Typography>
        </div>
      )}
    </>
  );
};

export default AgentFormDateInput;
